import { IPOSLocation } from 'components/menu/MenuPosApi';
import { PosLocationsActionTypes } from './posLocationsActionTypes';
import { IPosLocationsAction } from './posLocationsActions';

export interface PosLocationsState {
    posLocations: IPOSLocation[];
    loading: boolean;
}

export const initialState: PosLocationsState = {
    posLocations: [],
    loading: false
};

export default function (
    state: PosLocationsState = initialState,
    action: IPosLocationsAction
): PosLocationsState {
    switch (action.type) {
        case PosLocationsActionTypes.START_REQUEST:
            return { ...state, loading: true };
        case PosLocationsActionTypes.END_REQUEST:
            return { ...state, loading: false };
        case PosLocationsActionTypes.LOAD_SUCCESS:
            return {
                ...state,
                posLocations: action.posLocations,
                loading: false
            };
        case PosLocationsActionTypes.LOAD_ERROR:
            return {
                ...state,
                loading: false
            };
        case PosLocationsActionTypes.RESET:
            return { ...initialState };
        default:
            return state;
    }
}
